var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDineinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Dine_in",
    "data-name": "Logo Dine in",
    transform: "translate(21724 22661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299858",
    "data-name": "Path 299858",
    d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z",
    transform: "translate(-21724 -22661)",
    fill: "#7b8cc7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "restaurant_1_",
    "data-name": "restaurant (1)",
    transform: "translate(-21715.793 -22643.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109066",
    "data-name": "Path 109066",
    d: "M217.5,181.741a.493.493,0,0,0-.4-.244h-3.211c-.3,0-.537.308-.54.7a.934.934,0,0,0,.005.106l1.07,9.863a.607.607,0,0,0,.535.606h1.07a.607.607,0,0,0,.535-.606l1.07-9.863A.862.862,0,0,0,217.5,181.741Z",
    transform: "translate(-199.702 -177.545)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109067",
    "data-name": "Path 109067",
    d: "M159.318,330.832h-6.577c-1.816,0-3.288,1.028-3.288,2.3,0,.254.294.459.658.459h11.839c.363,0,.658-.206.658-.459C162.607,331.86,161.135,330.832,159.318,330.832Z",
    transform: "translate(-140.238 -316.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109068",
    "data-name": "Path 109068",
    d: "M86.11,138.832h19.731c.363,0,.658.184.658.411v1.644c0,.227-.294.411-.658.411H86.11c-.363,0-.658-.184-.658-.411v-1.644C85.452,139.016,85.747,138.832,86.11,138.832Z",
    transform: "translate(-80.183 -136.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27014",
    "data-name": "Group 27014",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109069",
    "data-name": "Path 109069",
    d: "M.665,134.511a.628.628,0,0,1-.132-.013.658.658,0,0,1-.513-.776h0l1.293-6.467L.007,118.16a.658.658,0,0,1,.553-.748l.013,0a.67.67,0,0,1,.75.566l1.315,9.208a.671.671,0,0,1,0,.221l-1.315,6.577A.658.658,0,0,1,.665,134.511Z",
    transform: "translate(0.001 -117.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109070",
    "data-name": "Path 109070",
    d: "M27.371,274.724a.658.658,0,0,1-.658-.658v-5.919h-4.6a.658.658,0,0,1,0-1.315h5.262a.658.658,0,0,1,.658.658v6.577A.658.658,0,0,1,27.371,274.724Z",
    transform: "translate(-20.129 -257.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109071",
    "data-name": "Path 109071",
    d: "M384.777,274.724a.658.658,0,0,1-.658-.658V267.49a.658.658,0,0,1,.658-.658h5.262a.658.658,0,1,1,0,1.315h-4.6v5.919A.658.658,0,0,1,384.777,274.724Z",
    transform: "translate(-360.434 -257.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109072",
    "data-name": "Path 109072",
    d: "M471.507,134.53a.658.658,0,0,1-.643-.526l-1.315-6.577a.668.668,0,0,1,0-.221L470.864,118a.664.664,0,0,1,.735-.568.658.658,0,0,1,.567.737l0,.013-1.3,9.1,1.286,6.464a.658.658,0,0,1-.517.773h0A.632.632,0,0,1,471.507,134.53Z",
    transform: "translate(-440.588 -117.424)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_299859",
    "data-name": "Path 299859",
    d: "M227.264.247a.593.593,0,1,1-1.185,0C226.078-.08,227.264-.08,227.264.247Zm0,0",
    transform: "translate(-211.283 -5.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299860",
    "data-name": "Path 299860",
    d: "M44.631,38.2a4.272,4.272,0,0,0-4.272,4.272H48.9A4.272,4.272,0,0,0,44.631,38.2Zm0,0",
    transform: "translate(-29.242 -43.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299861",
    "data-name": "Path 299861",
    d: "M226.927,38.2a4.3,4.3,0,0,0-.588.04,4.273,4.273,0,0,1,3.684,4.232H231.2A4.272,4.272,0,0,0,226.927,38.2Zm0,0",
    transform: "translate(-211.539 -43.187)",
    fill: "#e5ebff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299862",
    "data-name": "Path 299862",
    d: "M9.85,248.316H.293A.293.293,0,0,1,0,248.023v-.187a.293.293,0,0,1,.293-.293H9.85a.293.293,0,0,1,.293.293v.187A.293.293,0,0,1,9.85,248.316Zm0,0",
    transform: "translate(10.317 -248.384)",
    fill: "#e5ebff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDineinLogo);
export default __webpack_public_path__ + "static/media/ic-dinein-logo.cf6853cdc96c46ff6e08b7b2c9060d64.svg";
export { ForwardRef as ReactComponent };